export const VUEX_CONSTANTS_INIT = 'VUEX_CONSTANTS_INIT'
export const VUEX_CONSTANTS_INITIALIZED = 'VUEX_CONSTANTS_INITIALIZED'
export const VUEX_CONSTANTS_SET_ALL = 'VUEX_CONSTANTS_SET_ALL'
